import api from './api';
import API_ROUTES from './apiRoutes';

const authService = {
  mainLogin: async (credentials) => {
    const response = await api.post(API_ROUTES.AUTH.MAIN_LOGIN, credentials);
    return response.data;
  },

  login: async (credentials) => {
    const response = await api.post(API_ROUTES.AUTH.LOGIN, credentials);
    return response.data;
  },

  playerLogin: async (formData) => {
    const response = await api.post(API_ROUTES.AUTH.LOGIN_PLAYER, formData, {
      headers: {
        'Content-Type': undefined,
      },
    });
    return response.data;
  },

  register: async (userData) => {
    const response = await api.post(API_ROUTES.AUTH.REGISTER_PLAYER, userData, {
      headers: {
        'Content-Type': undefined,
      },
    });
    return response.data;
  },

  logout: async () => {
    const response = await api.post(API_ROUTES.AUTH.LOGOUT);
    return response.data;
  },

  refreshToken: async (refreshToken) => {
    const response = await api.post(API_ROUTES.AUTH.REFRESH, { refreshToken });
    return response.data;
  },

  forgotPassword: async (email) => {
    const response = await api.post(API_ROUTES.AUTH.FORGOT_PASSWORD, { email });
    return response.data;
  },

  verifyOtp: async (email, otp) => {
    const response = await api.post(API_ROUTES.AUTH.VERIFY_OTP, { email, otp });
    return response.data;
  },

  resetPassword: async (resetToken, newPassword, confirmPassword) => {
    const response = await api.put(API_ROUTES.AUTH.RESET_PASSWORD, {
      resetToken,
      newPassword,
      confirmPassword,
    });
    return response.data;
  },

  verifyEmail: async (token) => {
    const response = await api.post(API_ROUTES.AUTH.VERIFY_EMAIL, { token });
    return response.data;
  },
};

export default authService;
